module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-reservation-planner row column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Driver"), _c('SelectizeDriver', {
    model: {
      value: (_vm.driver),
      callback: function($$v) {
        _vm.driver = $$v
      },
      expression: "driver"
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Start Date"), _c('DatePicker', {
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Contract duration"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractDuration),
      expression: "contractDuration"
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.contractDuration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contractDuration = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Parking Lot"), _c('SelectizeParkingLot', {
    on: {
      "optionSelected": _vm.setParkingLot,
      "optionRemoved": _vm.unsetParkingSlot
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Plan to be activated (" + _vm._s(_vm.planId) + ")"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planId),
      expression: "planId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.planId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("- NO PLAN -")]), _vm._l((_vm.plans), function(p) {
    return _c('option', {
      domProps: {
        "value": p.id
      }
    }, [_vm._v(_vm._s(p.name))])
  })], 2)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Enable custom  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multipleMode),
      expression: "multipleMode"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.multipleMode) ? _vm._i(_vm.multipleMode, null) > -1 : (_vm.multipleMode)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.multipleMode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.multipleMode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.multipleMode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.multipleMode = $$c
        }
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [(_vm.plans.length > 0) ? _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Presets shifts"), _vm._l((_vm.shiftsPresets), function(p, i) {
    return (_vm.shiftsPresets) ? _c('div', {
      style: ({
        'background-color': p.color
      })
    }, [(_vm.multipleMode) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPresets[i]),
        expression: "selectedPresets[i]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.selectedPresets[i]) ? _vm._i(_vm.selectedPresets[i], null) > -1 : (_vm.selectedPresets[i])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPresets[i],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.selectedPresets, i, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.selectedPresets, i, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.selectedPresets, i, $$c)
          }
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPreset),
        expression: "selectedPreset"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": i,
        "checked": _vm._q(_vm.selectedPreset, i)
      },
      on: {
        "change": function($event) {
          _vm.selectedPreset = i
        }
      }
    }), _c('span', {
      staticStyle: {
        "font-family": "monospace"
      }
    }, [_vm._v("  [" + _vm._s(_vm.getPlanName(p.plan_id)) + "] " + _vm._s(p.shift))])]) : _vm._e()
  })], 2)]) : _vm._e(), (_vm.multipleMode) ? _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Custom shifts"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customShifts),
      expression: "customShifts"
    }],
    staticStyle: {
      "font-family": "monospace"
    },
    attrs: {
      "placeholder": "#C2C2C2 MON|TUE|WED|THU|FRI|SAT|SUN 08:00 09:00",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.customShifts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customShifts = $event.target.value
      }
    }
  })])]) : _vm._e()]), _c('br'), (_vm.multipleMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Selected shifts"), _vm._l((_vm.shifts), function(p) {
    return _c('div', [_c('ul', {
      staticStyle: {
        "font-family": "monospace"
      }
    }, [_c('li', [_vm._v(_vm._s(p))])])])
  })], 2)])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.search
    }
  }, [_vm._v("Search")])], 1)]), _vm._l((_vm.slotsByLots), function(slots, key) {
    return _c('div', {
      staticClass: "grouped card",
      style: (_vm.gridStyle(slots))
    }, [_c('h1', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle, id) {
      return (!vehicle.vehicle.disabled) ? _c('vehicle', {
        key: id,
        attrs: {
          "item": vehicle.vehicle,
          "type": "search-result"
        }
      }, [_c('ActionButton', {
        attrs: {
          "action": _vm.bookVehicle,
          "value": vehicle.vehicle.plate,
          "disabled": _vm.driver === null
        }
      }, [_vm._v("Book")])], 1) : _vm._e()
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25f37233!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReservationPlanner.vue
// module id = 2287
// module chunks = 1